import Price from './Price';

interface RawPrice {
	calculationType: string;
	formula: string;
}

export default function mapPrice(price: RawPrice): Price {
	return new Price(price.calculationType, price.formula);
}
